// AiButton.jsx
import React from "react";
//import './AiButton.scss'; // import SCSS

const AiButton = ({
  height = 32,
  label = "Dive deeper in AI Mode",
  onClick,
  className,
  url
}) => {
  return (
    <div
      className={`ai-button-container ${className}`}
      style={{ "--button-height": `${height}px` }}
    >
      <div className="button-wrapper">
        <div className="ai-button active" role="button" tabIndex={0}>
          <div>
            {/* Gradient Border Layer */}
            <div className="gradient-ring">
              <div className="gradient" />
            </div>

            {/* Inner Fill & Content */}
            <div className="gradient-ring">
              <div className="gradient" />
              <div className="button-fill" />
              <a href={url} target="_blank" onClick={() => onClick(true)}>
                <div className="button-content">
                  <div className="button-label">{label}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <div
    //   className="button-container"
    //   style={{ '--button-height': `${height}px` }}
    // >
    //   <div className="button-wrapper">
    //     <div className="ai-button active" role="button" tabIndex={0}>
    //       <div className="gradient-ring">
    //         <div className="gradient" />
    //       </div>
    //       <div className="gradient-ring">
    //         <div className="gradient" />
    //         <div className="button-fill" />
    //         <div className="button-content">
    //           <div className="button-label">{label}</div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default AiButton;
